import React, { useState, useRef, useEffect } from "react";

interface props {
  placeholder?: string;
  value: string;
  onChange: (e: any) => void;
  className?: string;
}
const ScrollableTextArea = ({
  placeholder,
  value,
  onChange,
  className = "",
}: props) => {
  const [hideLabel, setHideLabel] = useState(false);
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);

  const handleScroll = () => {
    if (textAreaRef.current) {
      setHideLabel(textAreaRef.current.scrollTop > 8);
    }
  };

  return (
    <div className="relative">
      <textarea
        ref={textAreaRef}
        onScroll={handleScroll}
        className={`w-full border resize-none ${className}`}
        value={value}
        onChange={onChange}
      />
      <label
        htmlFor="name"
        className={`absolute font-openSans font-normal ${
          hideLabel ? "hidden" : ""
        } left-4 transition-all duration-300 text-gray-400 top-[6px] text-[12px] leading-[13px] peer-focus:text-brand-orange`}
      >
        {placeholder}
      </label>
    </div>
  );
};

export default ScrollableTextArea;
